import React from 'react';
import createMuiTheme from '@material-ui/core/styles/createTheme';
import lightBlue from '@material-ui/core/colors/lightBlue';
import lightGreen from '@material-ui/core/colors/lightGreen';
import { ThemeProvider } from '@material-ui/core/styles';

import './Resources/Fonts/AeonikFont';

export const theme = createMuiTheme({
  palette: {
    secondary: lightBlue,
    primary: {
      ...lightGreen,
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: ['Aeonik', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h3: {
      fontSize: '1.125rem',
    },
    body1: {
      fontSize: 'inherit',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: 0,
      },
    },
  },
  media: {
    portrait: '@media (orientation: portrait)',
    landscape: '@media (orientation: landscape)',
  },
});

export const CustomThemeProvider = (props) => <ThemeProvider theme={theme} {...props} />;
